<template>
  <div>
    <!--convert longUrl to shortURl-->
    <v-card class="pa-4 rounded-lg" flat outlined>
      <v-card-title class="pa-2">
        ساخت لینک کوتاه
        <v-icon>mdi-link</v-icon>
        <v-divider class="ms-2" />
      </v-card-title>
      <v-progress-linear
        v-if="formLoading"
        indeterminate
        color="navy"
        class="mb-4"
      ></v-progress-linear>
      <v-row class="mt-4" no-gutters>
        <v-col cols="12" md="6" class="px-2">
          <v-text-field
            v-model="TitleUrl"
            class="rounded-lg v-input--dense pa-0 ma-0"
            outlined
            dense
            label="عنوان"
            validate-on-blur
            :rules="[rules.max]"
            clearable
            clear-icon="mdi-close-circle-outline"
            hint="لطفا یک نام برای لینک کوتاه خود اضافه کنید."
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2">
          <!-- <div v-if="loadingDomains" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
              size="24"
            ></v-progress-circular>
            <span class="ms-2">در حال بارگذاری دامنه‌ها...</span>
          </div> -->
          <v-select
            outlined
            :items="domains"
            v-model="selectedDomain"
            class="rounded-lg v-input--dense pa-0 ma-0"
            label="دامنه"
            dense
            :rules="[rules.required_domain]"
            hint="لطفا یک دامنه انتخاب کنید"
            :loading="loadingDomains"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="mt-4" no-gutters>
        <v-col cols="12" class="px-2">
          <v-text-field
            v-model="longUrl"
            class="rounded-lg v-input--dense pa-0 ma-0"
            outlined
            dense
            label="لینک"
            validate-on-blur
            :rules="[rules.required, rules.urlFormat]"
            clearable
            clear-icon="mdi-close-circle-outline"
            hint="لطفا لینک مورد نظر خود را وارد کنید."
            placeholder=" مانند http://www.google.com"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row class="mt-4" no-gutters>
        <v-col cols="12">
          <v-btn
            :disabled="!checkRules"
            class="btn-send-sms btn"
            @click="createShortUrl"
            :loading="loading"
            color="success"
            depressed
            >ساخت لینک کوتاه
            <v-icon>mdi-link-plus</v-icon>
          </v-btn>
        </v-col>

        <!-- // getFileType  -->
      </v-row>
    </v-card>
    <!--show message-->
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/style.shortlink.css";
import { GetDomain, AddLink } from "./axios_shortlink.js";
import { removehttp, checkUrl, isValidUrl } from "@/assets/js/FunctionLink.js";

export default {
  name: "addNewSingleShortLink",
  data() {
    return {
      TitleUrl: "",
      loading: false,
      loadingDomains: false,
      formLoading: false,
      shortUrls: [],
      longUrls: [],
      id_user: 1,
      isDeleteMistakeLink: false,
      numberofshortlink: 1,
      domains: [],
      selectedDomain: "t7r.ir",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      shortUrl: "",
      longUrl: "",
      rules: {
        required_domain: (value) =>
          !!value?.trim() ? true : "لطفا یک دامنه انتخاب کنید",
        required: (value) =>
          !!value?.trim() ? true : "لطفا آدرس اینترنتی را وارد کنید",
        urlFormat: (value) => {
          const pattern = new RegExp(
            "^(https?:\\/\\/|www\\.)?" + // پروتکل‌های مختلف یا www
              "(localhost|(([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" + // localhost یا دامین
              "(\\d{1,3}(\\.\\d{1,3}){3}))" + // آی‌پی‌ها
              "(\\:\\d+)?" + // پورت (اختیاری)
              "(\\/[-a-zA-Z\\d%_.~+]*)*" + // مسیر
              "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" + // کوئری پارامتر
              "(\\#(\\/[-a-zA-Z\\d%_.~+]*)?)?$", // هشتگ با مسیر اختیاری
            "i"
          );
          return !!value?.trim() && pattern.test(value)
            ? true
            : "لطفا آدرس اینترنتی معتبر وارد کنید";
        },
        max: (value) =>
          !!value && value.length <= 50
            ? true
            : "عنوان بیشتر از 50 حرف نباشد! لطفا عنوان کوتاه‌تری وارد کنید",
      },
    };
  },
  created() {
    this.initData();
    //this.loadShortLink();
  },
  computed: {
    // ...mapGetters(["ShortLinks", "ShortLinksUsers"]),
    checkRules() {
      return (
        this.rules.max(this.TitleUrl?.trim()) === true &&
        this.rules.urlFormat(this.longUrl) === true &&
        this.rules.required(this.longUrl) === true &&
        this.rules.required_domain(this.selectedDomain) === true
      );
    },
  },
  methods: {
    initData() {
      this.loadingDomains = true;
      GetDomain()
        .then((data) => {
          this.domains = data;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("خطا در دریافت دامنه:", error);
          this.showSnackbar("خطا در بارگذاری دامنه‌ها!", "error");
        })
        .finally(() => {
          this.loadingDomains = false;
        });
    },

    isExist(url) {
      if (!url) return false;
      url = url.trim().replace(/\/+$/, "").toLowerCase();
      return this.ShortLinks.some((p) => p.longUrl === url);
    },
    Back() {
      this.longUrl = "";
      this.shortUrl = "";
    },
    showSnackbar(message, color) {
      this.snackbar = false;
      this.$nextTick(() => {
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbar = true;
      });
    },
    createShortUrl() {
      this.loading = true;
      this.formLoading = true;
      if (!this.longUrl) {
        this.showSnackbar("لطفاً یک آدرس وارد کنید.", "error");
        this.loading = false;
        this.formLoading = false;
        return;
      }
      if (!this.selectedDomain) {
        this.showSnackbar("لطفاً یک دامنه انتخاب کنید.", "error");
        this.loading = false;
        this.formLoading = false;
        return;
      }
      if (!isValidUrl(this.longUrl)) {
        this.showSnackbar("لطفاً یک آدرس معتبر وارد کنید.", "error");
        this.loading = false;
        this.formLoading = false;
        return;
      }
      this.longUrl = checkUrl(this.longUrl);
      AddLink({
        title: this.TitleUrl,
        link: this.longUrl,
        type_id: 1,
        domainId: 1,
        created_at: new Date().toISOString().split(".")[0],
      })
        .then((response) => {
          this.shortUrl = response.link.link;
          this.shortUrl = removehttp(this.shortUrl);
          this.loading = false;
          this.$router.push("/shortlink");
        })
        .catch((error) => {
          console.error("خطا در ساخت لینک کوتاه:", error);
          this.$swal({
            title: "خطا!",
            text: "مشکلی در ساخت لینک کوتاه پیش آمد. لطفاً دوباره تلاش کنید.",
            icon: "error",
            confirmButtonText: "باشه",
          }).finally(() => {
            this.formLoading = false;
            this.loading = false;
          });
        });
    },
  },
};
</script>

<style scoped>
@media (max-width: 780px) {
  ::v-deep(.v-btn) {
    margin-top: 10px !important;
    padding-top: 10px !important;
  }
  ::v-deep(.v-text-field) {
    width: 100% !important;
    flex: 1 1 100%;
    margin-bottom: 10px !important;
  }
}
</style>
